import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function useOutsideAlerter(ref, onClick) {
  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      onClick();
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
}

function OutsideAlerter(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.onClick);

  return (
    <div style={{ flex: '1 1 auto' }} ref={wrapperRef}>
      {props.children}
    </div>
  );
}

OutsideAlerter.propTypes = {
  children: PropTypes.array,
  onClick: PropTypes.func,
};

export default OutsideAlerter;
